<script setup lang="ts">
import { useResolveLabel, useContext, useDialogs, useLocalization } from '@hantera/portal-app'
import { computed } from 'vue'
import CreateInventoryDialog from './CreateInventoryDialog.vue'

const t = useLocalization('settings.inventories')
const context = useContext()
const dialogs = useDialogs()
const { resolve: resolveLabel } = useResolveLabel()

const canWrite = computed(() => context.authorize('registry/inventories:write'))

const props = defineProps<{
  inventories: Array<{ key: string; data: Record<string, any> }>
  selectedKey: string | null
  loading: boolean
}>()

const emit = defineEmits<{
  (e: 'select', key: string | null): void
  (e: 'created', key: string): void
}>()


function openCreateDialog() {
  const existingKeys = props.inventories.map(i => i.key)
  dialogs.openModal(
    t('create.title'),
    CreateInventoryDialog,
    true,
    { existingKeys, onCreated: (key: string) => emit('created', key) }
  )
}
</script>

<template>
  <div class="sidebar-section" style="height: 100%">
    <div class="sidebar-header">
      <button
        v-if="canWrite"
        class="btn-primary"
        @click="openCreateDialog"
      >{{ t('createNew') }}</button>
    </div>

    <div v-if="loading" class="sidebar-loading">Loading...</div>

    <div v-else class="neat-scroll" style="flex: 1; overflow-y: auto">
      <div
        v-for="inv in inventories"
        :key="inv.key"
        :class="['sidebar-item', { 'sidebar-item--selected': inv.key === selectedKey }]"
        @click="emit('select', inv.key)"
      >
        <div class="sidebar-item-content">
          <div class="sidebar-item-label">{{ inv.key }}</div>
          <div class="sidebar-item-sub-label" v-if="resolveLabel(inv.data?.label)">{{ resolveLabel(inv.data?.label) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
